import {createRoot} from 'react-dom/client'
import '@maptiler/sdk/dist/maptiler-sdk.css'
import './index.css'
import App from './App'
import SignInPageComponent from './components/SignInPage/SignInPageComponent'
import {MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate} from '@azure/msal-react'
import {PublicClientApplication, EventType} from '@azure/msal-browser'
import {msalConfig} from './Auth/auth-config'
import {BrowserRouter} from 'react-router-dom'
import {ThemeProvider} from '@mui/material/styles'
import pTheme from './themes/pTheme/pTheme'
import {Provider} from 'react-redux'
import {store} from './store'

const msalInstance = new PublicClientApplication(msalConfig)
msalInstance.addEventCallback((message) => {
  if (message.eventType === EventType.HANDLE_REDIRECT_END) {
    const account = msalInstance.getAllAccounts()[0]
    if (!account) return
    const userEmail = account.username
    sessionStorage.setItem('userEmail', userEmail)
    // User data will be picked up by analytics when tracking events
  }
})
const root = createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <ThemeProvider theme={pTheme}>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <UnauthenticatedTemplate>
            <SignInPageComponent />
          </UnauthenticatedTemplate>
          <AuthenticatedTemplate>
            <App />
          </AuthenticatedTemplate>
        </BrowserRouter>
      </MsalProvider>
    </ThemeProvider>
  </Provider>
) /*
  - Initializes Mapbox worker for map rendering.
  - Configures MSAL instance and sets up event callback for user authentication handling.
  - Renders the React app with providers for authentication, routing, timeout, and custom dashboard views.
*/
